

// Badminton Image
import FrappeCRM from "./img/frappe-crm.jpeg";

// skill
import HTMLicon from "./img/skills/html5_icon.svg";
import CSSicon from "./img/skills/css_icon.svg";
import SASSicon from "./img/skills/sass_icon.svg";
import JSicon from "./img/skills/javascript_icon.svg";
import Reacticon from "./img/skills/reactjs_icon.svg";
import Reduxicon from "./img/skills/redux_icon.svg";
import Jqueryicon from "./img/skills/jquery_icon.svg";
import Resticon from "./img/skills/restful_icon.svg";
import Booticon from "./img/skills/bootstrap-5-1.svg";
import ReactBooticon from "./img/skills/react-boot.svg";
import MUIicon from "./img/skills/material-ui-1.svg";
import GITicon from "./img/skills/git-icon.svg";
// import VSCodeicon from "./img/skills/vscode.svg";
// import Sourceicon from "./img/sourcetree-1.svg";
const ProjectData = [
  {
    by: "prathivan",
    path: "project-fk",
    title: "Travel Bus Booking & Management System (Frappe Framework)",
    projdata: "This project is a comprehensive bus trip management platform developed using the Frappe Framework, designed to streamline operations for a client in the transport sector.",
    disc: [
      {
        title: "Doctype Architecture & Database Design",
        points: [
          "Created custom Doctypes and fields based on the client's operational requirements.",
          "Structured the database to support scalable management of trips, drivers, buses, and operational workflows."
        ]
      },
      {
        title: "Admin Panel Development",
        points: [
          "Built a dedicated admin dashboard to manage core functionalities of the platform.",
          "Enables administrators to oversee trip scheduling, driver assignments, bus maintenance, and leave approvals."
        ]
      },
      {
        title: "Trip Management System",
        points: [
          "Supports creation and management of both permanent and adhoc trips.",
          "Allows assignment of available drivers to trips based on their schedule and leave status."
        ]
      },
      {
        title: "Leave Management Module",
        points: [
          "Drivers can apply for leave directly from the mobile application.",
          "Leave requests are reflected in the admin panel for review and approval."
        ]
      },
      {
        title: "Adhoc Trip Request Workflow",
        points: [
          "Drivers can raise requests for adhoc trips via the mobile app.",
          "Requests are processed through workflow validation before assignment."
        ]
      },
      {
        title: "Master Data Management",
        points: [
          "Maintains structured records of all buses, drivers, routes, and trip histories.",
          "Ensures accurate and centralized data for better resource planning."
        ]
      },
      {
        title: "API Integration for Mobile Application (React Native)",
        points: [
          "Developed custom API methods for seamless communication between the React Native frontend and the Frappe backend.",
          "APIs handle trip submission, leave applications, trip listing, driver authentication, and real-time updates."
        ]
      },
    ],
    banner: FrappeCRM,
    type: "React Website",
    liveurl: "project-fk",
    status: 1,
    date: {
      startdate: "Jan 2023",
      enddate: "Nov 2023",
    },
    tech: [Reacticon, HTMLicon, CSSicon, SASSicon, Reduxicon, MUIicon, ReactBooticon, Resticon,],
  },
  {
    by: "prathivan",
    path: "project-iso",
    title: "ISO Certificate Management System (Frappe Framework)",
    projdata: "This project involves the complete development of a certificate lifecycle management system tailored to clients managing ISO certifications. The system was built using the Frappe Framework and followed a structured development approach, including requirement gathering, system architecture, and client collaboration.",
    disc: [
      {
        title: "Client Collaboration & Requirement Analysis",
        points: [
          "Initiated the project by interacting with the client to gather detailed functional requirements.",
          "Created a dummy layout site in Frappe to visualize the structure and proposed features.",
          "Designed the system architecture, created custom Doctypes and fields, and drafted a Scope of Work (SOW) document.",
          "Presented the workflow and system design to the client for approval before proceeding to development.",
        ]
      },
      {
        title: "System Development Based on Approved SOW",
        points: [
          "Developed the complete site according to the approved Scope of Work.",
          "Implemented all required functionalities for managing certification processes, including auto-renewal tracking, document uploads, due date alerts, and role-based access.",
        ]
      },
      {
        title: "Certificate Lifecycle Management Features",
        points: [
          "Built key modules for: Certificate Management, Automated Renewal Reminders, Due Date Tracking, Custom Dashboard for Quick Monitoring",
          "Ensured all features align with real-time usability and client operations.",
        ]
      },
      {
        title: "Client Demo & Final Handover",
        points: [
          "Delivered a working demo to the client upon completion of development.",
          "Incorporated client feedback and made necessary changes.",
          "Successfully handed over the finalized site to the client along with documentation and training support.",
        ]
      },
    ],
    banner: FrappeCRM,
    type: "React Website",
    liveurl: "project-iso",
    status: 1,
    date: {
      startdate: "Sep 2022",
      enddate: "Sep 2022",
    },
    tech: [Reacticon, HTMLicon, CSSicon, SASSicon, ReactBooticon, GITicon],
  },
  {
    by: "prathivan",
    path: "project-exotel",
    title: "Exotel Telephony Application Integration (Frappe + Exotel App)",
    projdata: "This project involved designing and developing a custom call management system by integrating the Exotel cloud telephony platform with a Frappe-based backend. The goal was to automate and streamline incoming call routing, user interactions, and support handling using Exotel's APIs.",
    disc: [
      {
        title: "Workflow Architecture Design",
        points: [
          "Designed a custom call flow architecture for Exotel using features like Pass Through, Connect, Connect Support and Greetings.",
          "Utilized Exotel’s App Bazaar tools to visually architect and implement the call flow logic tailored to client requirements.",
        ]
      },
      {
        title: "Backend Integration & API Method Development",
        points: [
          "Developed backend logic in Frappe to handle call routing using Exotel APIs.",
          "Custom functions were implemented for pass-through and connect actions, handling dynamic data and real-time decision-making.",
        ]
      },
      {
        title: "Dynamic Call Routing (Manager Identification)",
        points: [
          "Customized the Connect API to dynamically fetch the manager's contact number using the CallFrom parameter.",
          "Ensured automated call connection with the responsible manager based on caller input and predefined logic.",
        ]
      },
      {
        title: "Fallback Support Routing (Queue Logic)",
        points: [
          "If the manager is unavailable (e.g., already on a call), the system automatically routes the call to the support team using a queue-based transfer method.",
        ]
      },
      {
        title: "Call Transfer & Popup UI Enhancements",
        points: [
          "Designed a custom dialog box with user-friendly buttons to manually transfer calls.",
          "Enhanced the call transfer popup to auto-update with relevant notes from the Call Log document for better traceability and ease of use.",
        ]
      },
      {
        title: "Testing, Client Demo, and Deployment",
        points: [
          "Completed successful end-to-end testing of the entire workflow.",
          "Delivered a live demo to the client, incorporated feedback, and finalized implementation.",
          "Deployed the application into production after client approval.",
        ]
      },
    ],
    banner: FrappeCRM,
    type: "HTML Website",
    liveurl: ["project-exotel"],
    status: 1,
    date: {
      startdate: "Nov 2023",
      enddate: "Nov 2023",
    },
    tech: [HTMLicon, CSSicon, JSicon, Booticon, Jqueryicon],
  },
  {
    by: "prathivan",
    path: "project-custom-crm",
    title: "Custom CRM Application (Frappe Framework)",
    projdata: "This project involved designing and developing a custom call management system by integrating the Exotel cloud telephony platform with a Frappe-based backend. The goal was to automate and streamline incoming call routing, user interactions, and support handling using Exotel's APIs.",
    disc: [
      {
        title: "CRM Structure Customization & Portal Development",
        points: [
          "Designed and built a dedicated CRM site and portal from scratch.",
          "Enhanced core features including: Lead Monitoring & Tracking, Automated Lead Creation from form submissions, Storage & Data Management for lead documents and interaction logs",
        ]
      },
      {
        title: "Client Demo & Feedback Sessions",
        points: [
          "Conducted an interactive demo session to showcase the CRM's capabilities and user-friendly interface.",
          "Collected client feedback to tailor the solution further to their business needs.",
        ]
      },
      {
        title: "Client-Specific Customization",
        points: [
          "Customized the CRM structure to align with the client's unique business workflow and lead management process.",
          "Designed additional modules and dashboards specific to their operations.",
        ]
      },
      {
        title: "Functionality Enhancements",
        points: [
          "Added custom fields, workflows, and triggers based on evolving client requirements.",
          "Conducted a final demo session for client validation and approval.",
        ]
      },
      {
        title: "Post-Deployment Support & Maintenance",
        points: [
          "Provided ongoing support including: Third-party integrations, Query resolution sessions, Bug fixing and error handling",
          "Ensured smooth onboarding for client teams and maintained the system for reliability.",
        ]
      },
      {
        title: "Testing, Client Demo, and Deployment",
        points: [
          "Completed successful end-to-end testing of the entire workflow.",
          "Delivered a live demo to the client, incorporated feedback, and finalized implementation.",
          "Deployed the application into production after client approval.",
        ]
      },
    ],
    banner: FrappeCRM,
    type: "HTML Website",
    liveurl: ["project-custom-crm"],
    status: 1,
    date: {
      startdate: "Nov 2023",
      enddate: "Nov 2023",
    },
    tech: [HTMLicon, CSSicon, JSicon, Booticon, Jqueryicon],
  },
  {
    by: "prathivan",
    path: "custom-erp-syst-dev",
    projdata: "This project involved designing and developing a custom call management system by integrating the Exotel cloud telephony platform with a Frappe-based backend. The goal was to automate and streamline incoming call routing, user interactions, and support handling using Exotel's APIs.",
    title: "Custom ERP System Development & Deployment (Frappe Framework & ERP Next)",
    disc: [
      {
        title: "Client Demo & Module Presentation",
        points: [
          "Conducted detailed demo sessions for the client, explaining core ERP modules such as: Store & Inventory Management, Manufacturing Workflow, Job Cards & Operations, Auditing & HR Management, Custom Reports & Tree Structures",
          "Helped the client visualize how each module aligns with their real-world processes.",
        ]
      },
      {
        title: "Requirement Gathering & Custom ERP Setup",
        points: [
          "Analyzed the client's business workflows and tailored the ERP system accordingly.",
          "Developed a new ERP site with custom modules, fields, and automation rules to meet specific operational needs.",
        ]
      },
      {
        title: "Workflow Configuration & System Testing",
        points: [
          "Set up and tested all workflows, including: Operations and Job Card Flow, Recipe/BOM Creation, Store Management Procedures",
          "Ensured process efficiency and data consistency throughout the system.",
        ]
      },
      {
        title: "Custom Reports & Dashboards",
        points: [
          "Designed and developed customized dashboards and report views to provide clear, real-time insights for management.",
          "Configured role-based reporting access and visual analytics as per client requests.",
        ]
      },
      {
        title: "Client Training & Project Handover",
        points: [
          "Delivered hands-on training sessions for end users and admins.",
          "Provided post-deployment support including query resolution, minor adjustments, and documentation.",
          "Successfully handed over the fully tested and functional ERP system to the client.",
        ]
      },
    ],
    banner: FrappeCRM,
    type: "React Website",
    liveurl: ["custom-erp-syst-dev"],
    status: 1,
    date: {
      startdate: "Oct 2023",
      enddate: "Oct 2023",
    },
    tech: [Reacticon, HTMLicon, CSSicon, SASSicon, ReactBooticon],
  },
];

export default ProjectData;
